// extracted by mini-css-extract-plugin
export default {"btn":"Dropdown--btn--+66q6","icon":"Dropdown--icon--mi7GY","list":"Dropdown--list--HsQgA","item":"Dropdown--item--s5lgn"};